import dayjs from 'dayjs';
import { ACTIVE_STATUS } from 'shared/constants/obu';

// 1 - простой от 0 до 4-х часов,
// 2 - простой от 4-х до 10-и частов,
// 3 - простой больше 10-и часов
export const getAutoStatusByDate = (date: Nullable<string>) => {
  if (!date) {
    return ACTIVE_STATUS.INACTIVE;
  }

  const lastActiveDate = dayjs(date);
  const nowDate = dayjs();

  const diffHours = Math.round(dayjs.duration(nowDate.diff(lastActiveDate)).asHours());

  if (diffHours < 4) {
    return ACTIVE_STATUS.FROM_0_TO_4_HOURS;
  }

  if (diffHours >= 4 && diffHours <= 10) {
    return ACTIVE_STATUS.FROM_4_TO_10_HOURS;
  }

  return ACTIVE_STATUS.MORE_10;
};
